import React from 'react';
import moment from 'moment';
function getIntervalTime(time) {
    var now = moment();
    if (time.diff(now, 'minutes') === 0) {
        return time.isAfter(now)
            ? time.diff(now, 'milliseconds') % 1000 + 1
            : 1001 - (Math.abs(time.diff(now, 'milliseconds')) % 1000); // ms until next second
    }
    else if (time.diff(now, 'hours') === 0) {
        return (time.isAfter(now)
            ? time.diff(now, 'seconds') % 30 + 1
            : 31 - (Math.abs(time.diff(now, 'seconds')) % 30)) * 1000; // ms until next minute
    }
    else if (time.diff(now, 'days') === 0) {
        return (time.isAfter(now)
            ? time.diff(now, 'minutes') % 30 + 1
            : 31 - (Math.abs(time.diff(now, 'minutes')) % 30)) * 60000; // ms until next hour
    }
}
function getString(time) {
    var now = moment();
    if (time.diff(now, 'minutes') === 0) {
        return "".concat(Math.abs(time.diff(now, 'seconds')), "s"); // seconds
    }
    else if (time.diff(now, 'hours') === 0) {
        return "".concat(Math.abs(time.diff(now, 'minutes')), "m"); // minutes
    }
    else if (time.diff(now, 'days') === 0) {
        return "".concat(Math.abs(time.diff(now, 'hours')), "h"); // hours
    }
    return "";
}
export function TimeFromNow(_a) {
    var time = _a.time, className = _a.className, explicit = _a.explicit;
    var constructed = React.useMemo(function () { return moment(time); }, [time]);
    var _b = React.useState(), fromNow = _b[0], setFromNow = _b[1];
    React.useEffect(function () {
        var timeoutHandle;
        function nextRefresh() {
            if (explicit) {
                setFromNow(getString(constructed));
            }
            else {
                setFromNow(constructed.fromNow());
            }
            var timeout = getIntervalTime(constructed);
            if (timeout) {
                timeoutHandle = setTimeout(nextRefresh, timeout);
            }
        }
        nextRefresh();
        return function () { return clearTimeout(timeoutHandle); };
    }, [constructed, explicit]);
    return React.createElement("span", { className: className }, fromNow);
}
